export default "__VITE_ASSET__f84b5ef4__"